// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a9e15fc","239":"d1f14ed6","455":"bed5f72e"}[chunkId] + ".chunk.js";
};